import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/newPhone/likeSetting.svg'


const _withScopeId = n => (_pushScopeId("data-v-00a177d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_set_wrap select_none" }
const _hoisted_2 = { class: "mod_c_title flex" }
const _hoisted_3 = {
  key: 1,
  class: "flex worp"
}
const _hoisted_4 = { class: "worp_left" }
const _hoisted_5 = { class: "cv_img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_8 = { class: "worp_right" }
const _hoisted_9 = { class: "bubble_box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "气泡样式：", -1))
const _hoisted_11 = { class: "item_title" }
const _hoisted_12 = { class: "item_con flex" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "新增样式", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { class: "span" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "item" }
const _hoisted_22 = { class: "item" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "  2、该数据只为前端用户展现, 后台数据以真实数据统计。", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "  3、建议上传图片比例为1 : 1，支持格式png、jpg、gif。", -1))
const _hoisted_26 = { class: "item" }

import { ref, computed, unref, inject } from 'vue';
import Crumb from '@/components/Crumb.vue';
import { useRoute } from 'vue-router';
import { DataTypeClass, FileInfo, imageList } from './liveAssist';
import { InputNumber, message, Radio } from 'ant-design-vue';
import { fabulous1, fabulous2, fabulous3, fabulous4, fabulous5, fabulous6, fabulous7 } from '@/assets';
import CUpload from '@/components/CUpload.vue';
import http from '@/api';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { LiveInfo } from '@/store/modules/live/types';
import CLoading from '@/components/CLoading.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LikeSetting',
  setup(__props) {

const liveInfo = computed(() => unref(inject('liveInfo')) as LiveInfo);

const aInputNumber = InputNumber;
const aRadioGroup = Radio.Group;
const route = useRoute();
const studioId = computed(() => route.params.studioId);

const objdata = ref<DataTypeClass>({
  status: false,
  index: 0,
  image_list: [],
  false_switch: 0,
  false_min: 1,
  false_max: 1,
  false_final: 0, //虚拟点赞基数
  real_num: 0, //真实点赞数
  count: 0, //总数
  false_num: 0, //虚拟点赞数
});

const imgArr = [fabulous1, fabulous2, fabulous3, fabulous4, fabulous5, fabulous6, fabulous7];

const showLoading = ref(false);
const listArr = ref<imageList[]>([]);
const getFabulousData = () => {
  showLoading.value = true;
  http.likesetting
    .getFabulousData({ params: { studio_id: studioId.value } })
    .then((res) => {
      objdata.value = new DataTypeClass(res.data.data);
      listArr.value = objdata.value.image_list;
      if (listArr.value.length === 1 && listArr.value[0].img_list.length === 0) {
        listArr.value[0].img_list = listArr.value[0].img_list.concat(imgArr);
      }
      listArr.value.forEach((item) => (item.loading = false));
    })
    .catch((err) => {
      console.error(err.data.error);
    })
    .finally(() => (showLoading.value = false));
};
getFabulousData();

const creatArr = () => {
  listArr.value.push({
    name: '自定义',
    img_list: [],
  });
};

const delArr = (index: number) => {
  listArr.value.splice(index, 1);
};

const fileList = ref([]);
const handleChange = (info: FileInfo, index: number) => {
  if (info.file.status === 'uploading') {
    listArr.value[index].loading = true;
  } else {
    listArr.value[index].loading = false;
  }
  if (info.file?.response?.code === 200) {
    listArr.value[index].img_list.push(info.file?.response?.data.url);
  }
};
const imageDel = (item: any, o: number) => {
  item.img_list.splice(o, 1);
};

const clickSave = useDebounce(() => {
  listArr.value.forEach((item) => delete item.loading);
  const data = {
    studio_id: studioId.value,
    status: objdata.value.status ? 1 : 0,
    false_switch: objdata.value.false_switch,
    false_min: objdata.value.false_min,
    false_max: objdata.value.false_max,
    false_final: objdata.value.false_final,
    index: objdata.value.index,
    real_num: objdata.value.real_num,
    image_list: JSON.stringify(listArr.value),
  };
  http.likesetting
    .setFabulousData(data)
    .then((res) => {
      message.success(res.data.message);
    })
    .catch((err) => {
      message.error(err.data.error);
    });
});

return (_ctx: any,_cache: any) => {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_unref(route).meta?.title), 1),
        _createVNode(_component_a_switch, {
          style: {"margin-left":"20px"},
          checked: objdata.value.status,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((objdata.value.status) = $event)),
          onChange: _unref(clickSave)
        }, null, 8, ["checked", "onChange"])
      ]),
      (showLoading.value)
        ? (_openBlock(), _createBlock(CLoading, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("img", {
                  src: _unref(liveInfo).image_player_cover_url
                }, null, 8, _hoisted_6), [
                  [_vShow, _unref(liveInfo).image_player_cover_url]
                ])
              ]),
              _hoisted_7
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listArr.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "sty_box"
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_unref(aRadioGroup), {
                        value: objdata.value.index,
                        "onUpdate:value": ($event: any) => ((objdata.value.index) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: index }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: item.name,
                                "onUpdate:value": ($event: any) => ((item.name) = $event),
                                readonly: index === 0,
                                class: "input"
                              }, null, 8, ["value", "onUpdate:value", "readonly"])
                            ]),
                            _: 2
                          }, 1032, ["value"])
                        ]),
                        _: 2
                      }, 1032, ["value", "onUpdate:value"])
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.img_list, (i, o) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: o,
                          class: "img_box"
                        }, [
                          _createElementVNode("img", { src: i }, null, 8, _hoisted_13),
                          _withDirectives(_createElementVNode("div", {
                            class: "img_top_right",
                            onClick: ($event: any) => (imageDel(item, o))
                          }, "×", 8, _hoisted_14), [
                            [_vShow, index > 0]
                          ])
                        ]))
                      }), 128)),
                      (index != 0 && item.img_list.length < 7)
                        ? (_openBlock(), _createBlock(CUpload, {
                            key: 0,
                            "file-list": fileList.value,
                            "upload-text": false,
                            loading: item.loading,
                            "handle-change": (info) => handleChange(info, index),
                            class: "upload"
                          }, null, 8, ["file-list", "loading", "handle-change"]))
                        : _createCommentVNode("", true)
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "top_right",
                      onClick: ($event: any) => (delArr(index))
                    }, "×", 8, _hoisted_15), [
                      [_vShow, listArr.value.length > 1 && index > 0]
                    ])
                  ]))
                }), 128)),
                (listArr.value.length < 3)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "add_box",
                      onClick: creatArr
                    }, _hoisted_17))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(" 真实点赞数量： "),
                _createElementVNode("span", _hoisted_19, _toDisplayString(objdata.value.real_num), 1)
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(" 虚拟点赞开关： "),
                _createVNode(_unref(aRadioGroup), {
                  value: objdata.value.false_switch,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((objdata.value.false_switch) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: 0 }, {
                      default: _withCtx(() => [
                        _createTextVNode("关")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("开")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createTextVNode(" 虚拟点赞基数： "),
                _createVNode(_unref(aInputNumber), {
                  value: objdata.value.false_final,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((objdata.value.false_final) = $event))
                }, null, 8, ["value"]),
                _createTextVNode("  ")
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createTextVNode(" 虚拟倍数：每点赞一次，虚拟增加  "),
                _createVNode(_unref(aInputNumber), {
                  value: objdata.value.false_min,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((objdata.value.false_min) = $event)),
                  min: 1,
                  max: 999
                }, null, 8, ["value"]),
                _createTextVNode(" - "),
                _createVNode(_unref(aInputNumber), {
                  value: objdata.value.false_max,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((objdata.value.false_max) = $event)),
                  min: 1,
                  max: 999
                }, null, 8, ["value"]),
                _createTextVNode("  次 ")
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("p", null, " 注：1、显示点赞数(" + _toDisplayString(objdata.value.count) + ") = 真实点赞数(" + _toDisplayString(objdata.value.real_num) + ") + 虚拟点赞数(" + _toDisplayString(objdata.value.false_num) + ") + 虚拟点赞基数(" + _toDisplayString(objdata.value.false_final) + ") ", 1),
                _hoisted_24,
                _hoisted_25
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _unref(clickSave)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]))
    ])
  ], 64))
}
}

})